<template>
  <div class="entry-bar-box">
    <el-radio-button-dict size="mini" class="radio-button-dict" dictType="ENTRY_BAR" v-model="radio"
      @dictChange="handleRadioChange"></el-radio-button-dict>
    <div id="entryBar" class="chart"></div>
  </div>
</template>
<script>
import { statisticsApi } from "@/api"
export default {
  name: "wareHousePie",
  data() {
    return {
      myChart: null,
      radio: "month",
      yearData: [],
      monthData: []
    }
  },
  created() {
    this.getInventoryStatistics()
  },
  methods: {
    resize() {
      this.myChart&&this.myChart.resize()
    },
    // 统计类型改变事件
    handleRadioChange(val) {
      const data = val === "month" ? this.monthData : this.yearData
      const total = data.reduce((acc, item) => acc + item.value, 0)
      const average = total / data.length
      if (!this.myChart) {
        this.$nextTick(() => {
          this.drawChars(data)
        })
      } else {
        var option = this.myChart.getOption()
        option.series[0].data = data.map(item => item.value)
        option.xAxis[0].data = data.map(item => item.name)
        option.series[0].markLine.data[0].label.formatter = `${average.toFixed(2)}`
        this.myChart.setOption(option)
      }
    },
    getInventoryStatistics() {
      statisticsApi.getInventoryStatistics().then(res => {
        this.yearData = res.yearData
        this.monthData = res.monthData
        this.handleRadioChange(this.radio)
      })
    },
    drawChars(data) {
      var chartDom = document.getElementById("entryBar")
      this.myChart = this.$echarts.init(chartDom)
      var option
      // 计算平均值
      const total = data.reduce((acc, item) => acc + item.value, 0)
      const average = total / data.length
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "3%",
          top: "6%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: data.map(item => item.name),
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "生产入库",
            type: "bar",
            barWidth: "50%",
            data: data.map(item => item.value),
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1, // 渐变方向从上到下
                [
                  { offset: 0, color: "#83bff6" }, // 渐变起始颜色
                  { offset: 1, color: "#188df0" } // 渐变结束颜色
                ]
              )
            },
            markLine: {
              data: [
                {
                  name: "平均值",
                  yAxis: average,
                  lineStyle: {
                    color: "#83bff6",
                    type: "dashed"
                  },
                  label: {
                    show: true,
                    position: "end", // 将标签位置设置为 end
                    offset: [-30, -10], // 水平向左 偏移 30 像素 垂直向上偏移 10 像素
                    formatter: `${average.toFixed(2)}`
                    // backgroundColor: "rgba(0, 0, 0, 0.7)", // 设置背景颜色
                    // color: "#fff", // 设置文字颜色
                    // padding: [5, 10], // 设置内边距
                    // borderRadius: 4 // 设置圆角
                  }
                }
              ]
            }
          }
        ]
      }

      option && this.myChart.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
.entry-bar-box {
  width: 100%;
  height: 100%;
  position: relative;

  .radio-button-dict {
    position: absolute;
    top: -30px;
    right: 0;
  }

  .chart {
    width: 100%;
    height: 100%;
  }
}
</style>
